import { ComponentView, ObservableArray, View, ViewGenerator, ViewModel } from "binder"
import { PaginatorViewModel } from "../../paginator/paginator-viewModel";
import { getAsBoolean } from "../../utilities";
import { ExTableViewModel } from "../exTable-viewModel";

export class ExtablePhoneView extends ComponentView<ExTableViewModel>{
    GetViewUniqueId(): string {
        return "V-D1E8015B-816F-4527-AFB6-498027A1DA05"
    }
    loadHtml(): string {
        let element = require('./extablePhone.html').default;
        let style = require('./extablePhone.less');
        return element;
    }
    constructor() {
       super();
       this.displayContentForTBody = false;
    }

    private itemTemplate : Node;
    templateSelector(vm){
        return ViewGenerator.GetNodeByTemplate(vm,this.itemTemplate);
    }
    append(...nodes: (Node | string)[]): void{
        let table = this.firstlevelElement.querySelector('.V-B7445FEA-BFC9-4BEE-8B62-92093F23D6F0-table');
        nodes.forEach(node=>{
            if(node instanceof HTMLTableSectionElement || node instanceof HTMLTableColElement){
                if(node.nodeName.toUpperCase()=='THEAD' || node.nodeName.toUpperCase()=="COLGROUP"){
                    table.prepend(node);
                }else if(node.nodeName.toUpperCase()=='TBODY'){
                    if(node.classList.contains("template")){
                        let template = <HTMLElement>node;
                        this.itemTemplate = this.removeAsTemplate(template);
                        this.displayContentForTBody = true;
                    }else if(node.childElementCount>0 && node.children[0].classList.contains("template")){
                        let template = <HTMLElement>node.children[0];
                        this.itemTemplate = this.removeAsTemplate(template);
                    }
                }else{
                    table.append(node);
                }
            }
        });
    }

    public set showingitems(v: ObservableArray<ViewModel>) { this._showingitems = v; } public get showingitems(): ObservableArray<ViewModel> { return this._showingitems;} private _showingitems: ObservableArray<ViewModel>;
    public set paginator(v: PaginatorViewModel) { this._paginator = v; } public get paginator(): PaginatorViewModel { return this._paginator;} private _paginator: PaginatorViewModel;
    public set stickyheader(v: boolean) { this._stickyheader = getAsBoolean(v); } public get stickyheader(): boolean { return this._stickyheader;} private _stickyheader: boolean;
    public set hidepages(v: boolean) { this._hidepages = v; } public get hidepages(): boolean { return this._hidepages;} private _hidepages: boolean;
    public set displayContentForTBody(v: boolean) { this._displayContentForTBody = v; } public get displayContentForTBody(): boolean { return this._displayContentForTBody;} private _displayContentForTBody: boolean;

}
